// extracted by mini-css-extract-plugin
module.exports = {"Amy":"TextGroupSectionE_Amy__2U9oN","TextContainer":"TextGroupSectionE_TextContainer__39P2J"};